<template>
  <div class="panel-distribuidor tw-min-h-screen tw-w-full tw-bg-gray-50 dark:tw-bg-[#0a0f18] tw-py-8 tw-transition-colors">
    <div class="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
      
      <!-- HEADER -->
      <div class="tw-mb-8 tw-flex tw-flex-col md:tw-flex-row md:tw-items-end tw-justify-between tw-gap-4">
        <div>
          <h1 class="tw-text-3xl tw-font-bold tw-text-gray-900 dark:tw-text-white tw-mb-2">Herramientas de Distribuidor</h1>
          <p class="tw-text-gray-600 dark:tw-text-gray-400">Encuentra aquí todos los cursos de pago, su material promocional y tu enlace de referido para empezar a compartir.</p>
        </div>
        
        <!-- Search Bar -->
        <div class="tw-w-full md:tw-w-72 tw-relative">
          <div class="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
            <i class="fas fa-search tw-text-gray-400 dark:tw-text-gray-500"></i>
          </div>
          <input 
            type="text" 
            v-model="searchQuery" 
            placeholder="Buscar por nombre..." 
            class="tw-w-full tw-pl-10 tw-pr-4 tw-py-2 tw-border tw-border-gray-300 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-text-gray-900 dark:tw-text-white placeholder:tw-text-gray-400 dark:placeholder:tw-text-gray-500 tw-rounded-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-border-transparent tw-transition-all"
            style="focus:ring-color: var(--primary-color, #18d600);"
          >
        </div>
      </div>

      <!-- ============ MI LANDING SECTION ============ -->
      <div class="tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-xl tw-shadow-sm tw-p-6 tw-mb-8">
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-gap-4 tw-mb-4">
          <div>
            <h2 class="tw-text-xl tw-font-bold tw-text-gray-900 dark:tw-text-white tw-flex tw-items-center tw-gap-2">
              <svg class="tw-w-6 tw-h-6 tw-text-[var(--primary-color,#18d600)]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path></svg>
              Mi Landing
            </h2>
            <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-mt-1">Tu página personalizada para compartir con tus prospectos. Los que se registren desde aquí quedan como tus referidos.</p>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
            <a :href="landingUrl" target="_blank" class="tw-bg-gray-100 hover:tw-bg-gray-200 dark:tw-bg-gray-700 dark:hover:tw-bg-gray-600 tw-text-gray-700 dark:tw-text-gray-200 tw-border dark:tw-border-gray-600 tw-font-semibold tw-text-sm tw-px-4 tw-py-2 tw-rounded-lg tw-transition-colors tw-inline-flex tw-items-center tw-gap-1">
              <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
              Ver mi Landing
            </a>
          </div>
        </div>

        <!-- Link to copy -->
        <div class="tw-flex tw-items-center tw-gap-2 tw-bg-gray-50 dark:tw-bg-gray-900/60 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-lg tw-p-3 tw-mb-4">
          <svg class="tw-w-5 tw-h-5 tw-text-gray-400 dark:tw-text-gray-500 tw-flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
          <input
            type="text"
            :value="landingFullUrl"
            readonly
            class="tw-flex-1 tw-bg-transparent tw-text-gray-700 dark:tw-text-gray-200 tw-text-sm tw-font-mono tw-outline-none tw-border-none"
          />
          <button
            @click="copyLandingLink"
            class="tw-bg-[var(--primary-color,#18d600)] hover:tw-opacity-90 tw-text-white tw-font-bold tw-text-sm tw-px-4 tw-py-2 tw-rounded-lg tw-transition-all tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0"
          >
            <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path></svg>
            {{ linkCopied ? '¡Copiado!' : 'Copiar' }}
          </button>
        </div>

        <!-- Highlighted courses selection -->
        <div class="tw-border-t tw-border-gray-100 dark:tw-border-gray-700 tw-pt-4">
          <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
            <h3 class="tw-text-sm tw-font-bold tw-text-gray-700 dark:tw-text-gray-300 tw-uppercase tw-tracking-wide">Cursos Destacados en tu Landing ({{ highlightedCourseIds.length }}/20)</h3>
            <button
              v-if="hasUnsavedChanges"
              @click="saveLandingSettings"
              :disabled="savingSettings"
              class="tw-bg-[var(--primary-color,#18d600)] hover:tw-opacity-90 tw-text-white tw-font-bold tw-text-sm tw-px-4 tw-py-2 tw-rounded-lg tw-transition-all disabled:tw-opacity-50"
            >
              {{ savingSettings ? 'Guardando...' : '💾 Guardar cambios' }}
            </button>
          </div>
          <p class="tw-text-xs tw-text-gray-400 dark:tw-text-gray-400 tw-mb-3">Marca con ⭐ los cursos que quieres destacar en el slider de tu landing. Máximo 20.</p>
        </div>
      </div>

      <!-- LOADING STATE -->
      <div v-if="loading" class="tw-flex tw-justify-center tw-items-center tw-py-20">
        <div class="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-b-2 tw-border-emerald-500"></div>
      </div>

      <!-- ERROR STATE -->
      <div v-else-if="error" class="tw-bg-red-50 dark:tw-bg-red-950/40 tw-text-red-600 dark:tw-text-red-400 tw-border dark:tw-border-red-800 tw-p-4 tw-rounded-xl tw-text-center">
        Error al cargar los cursos. Por favor, intenta de nuevo más tarde.
      </div>

      <!-- COURSES GRID -->
      <div v-else-if="filteredCourses.length > 0" class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
        <div v-for="course in filteredCourses" :key="course.id" class="tw-bg-white dark:tw-bg-gray-800 tw-shadow-sm tw-border tw-border-gray-100 dark:tw-border-gray-700 tw-rounded-xl tw-overflow-hidden hover:tw-shadow-lg dark:hover:tw-border-gray-600 tw-transition-all tw-flex tw-flex-col">
          
          <!-- Course Image -->
          <div class="tw-relative tw-w-full tw-pt-[56.25%] tw-bg-gray-100 dark:tw-bg-gray-900">
            <img 
              :src="getCourseImage(course)" 
              :alt="course.title" 
              class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-object-cover" 
              @error="onCourseImgError"
            />
            <div class="tw-absolute tw-top-3 tw-right-3 badge-price">
              ${{ getCoursePrice(course) }}
            </div>
            <!-- Star toggle for landing highlight -->
            <button
              @click.stop="toggleHighlight(course)"
              class="tw-absolute tw-top-3 tw-left-3 tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200"
              :class="isHighlighted(course.id) ? 'tw-bg-yellow-400 tw-text-white tw-shadow-lg' : 'tw-bg-white/80 dark:tw-bg-gray-900/80 tw-text-gray-400 dark:tw-text-gray-300 hover:tw-bg-yellow-100 dark:hover:tw-bg-yellow-900/40 hover:tw-text-yellow-500'"
              :title="isHighlighted(course.id) ? 'Quitar de landing' : 'Destacar en landing'"
            >
              ⭐
            </button>
          </div>

          <!-- Course Info -->
          <div class="tw-p-5 tw-flex tw-flex-col tw-flex-grow">
            <h3 class="tw-text-lg tw-font-bold tw-text-gray-900 dark:tw-text-white tw-mb-2">{{ course.title }}</h3>
            <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300 tw-line-clamp-3 tw-mb-4">{{ course.description }}</p>
            
            <!-- Acción: Publicitar -->
            <button 
              @click="goToDetails(course)"
              class="btn-share tw-mt-auto"
            >
              Publicitar
            </button>
          </div>
        </div>
      </div>

      <!-- EMPTY STATE (SEARCH) -->
      <div v-else class="tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-p-8 tw-rounded-xl tw-text-center tw-text-gray-500 dark:tw-text-gray-400">
        <i class="fas fa-search tw-text-4xl tw-mb-3 tw-text-gray-300 dark:tw-text-gray-600"></i>
        <p class="tw-text-lg tw-font-semibold tw-text-gray-900 dark:tw-text-white">No se encontraron cursos</p>
        <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">Intenta con otros términos de búsqueda.</p>
      </div>

    </div>

    <!-- Reusable Custom Alert (if applicable, else just use a native toast or sweetalert) -->
    <CustomAlert 
      v-if="alert.show"
      :type="alert.type"
      :message="alert.message"
      :defaultTitle="alert.title"
      class="tw-fixed tw-bottom-4 tw-right-4 tw-z-50"
    />
  </div>
</template>

<script>
import { authGet } from "@/helpers/authStorage";
import CustomAlert from "@/components/CustomAlert.vue";

export default {
  name: "PanelDistribuidor",
  components: {
    CustomAlert
  },
  data() {
    return {
      courses: [],
      searchQuery: '',
      loading: true,
      error: false,
      user: null,
      alert: {
        show: false,
        type: 'success',
        title: '',
        message: ''
      },
      // Landing settings
      highlightedCourseIds: [],
      savedHighlightedIds: [],
      linkCopied: false,
      savingSettings: false,
      username: authGet('username') || ''
    };
  },
  computed: {
    filteredCourses() {
      if (!this.searchQuery) return this.courses;
      const query = this.searchQuery.toLowerCase();
      return this.courses.filter(course => {
        return course.title && course.title.toLowerCase().includes(query);
      });
    },
    landingUrl() {
      return `/ref/${this.username}`;
    },
    landingFullUrl() {
      return `${window.location.origin}/ref/${this.username}`;
    },
    hasUnsavedChanges() {
      if (this.highlightedCourseIds.length !== this.savedHighlightedIds.length) return true;
      return JSON.stringify(this.highlightedCourseIds) !== JSON.stringify(this.savedHighlightedIds);
    }
  },
  async created() {
    // Get user from local storage
    const userStr = authGet();
    if (userStr) {
      try {
        this.user = JSON.parse(userStr);
      } catch (e) {
        console.error("Error parsing user:", e);
      }
    }
    this.username = authGet('username') || (this.user && this.user.username) || '';
    
    await Promise.all([
      this.fetchPaidCourses(),
      this.fetchLandingSettings()
    ]);
  },
  methods: {
    async fetchPaidCourses() {
      try {
        this.loading = true;
        // Obtenemos todos los productos del marketplace (cursos, libros, etc.)
        const response = await this.axios.get("marketing/marketplace/courses?per_page=100");
        if (response.data && response.data.data) {
          // Extraemos la data de la respuesta paginada
          const fetchedCourses = response.data.data.data || response.data.data;
          
          // No filtramos por precio mayor a cero para asegurar que aparezcan libros y otros productos
          this.courses = fetchedCourses;
        }
      } catch (err) {
        console.error("Error fetching courses for distributor panel:", err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    getCourseImage(course) {
      const url = course.url_portada || course.image || course.url_front_page;
      if (!url) return require("@/assets/background-login.webp");
      
      if (url.startsWith('http')) {
        return url.replace('s3.sa-east-1', 's3-accelerate');
      }
      
      return "https://promolider-storage-user.s3-accelerate.amazonaws.com/" + url;
    },
    onCourseImgError(e) {
      if (e?.target) {
        e.target.src = require("@/assets/background-login.webp");
      }
    },
    getCoursePrice(course) {
      if (course.price) return parseFloat(course.price).toFixed(2);
      if (course.price_base) return parseFloat(course.price_base).toFixed(2);
      return '0.00';
    },
    goToDetails(course) {
      this.$router.push({ name: 'PanelDistribuidorCurso', params: { id: course.id } });
    },
    copyShareLink(course) {
      const idUser = authGet("id_user");
      if (!idUser) {
        this.showAlert('error', 'Error', 'No se pudo obtener tu usuario de referido.');
        return;
      }

      // Estructura del link: /landing/course/{id}?ref={id_user}
      const baseUrl = window.location.origin;
      const shareUrl = `${baseUrl}/landing/course/${course.id}?ref=${idUser}`;
      
      navigator.clipboard.writeText(shareUrl).then(() => {
        this.showAlert('success', '¡Enlace Copiado!', `El enlace de referido para "${course.title}" se copió al portapapeles.`);
      }).catch(err => {
        console.error('Error al copiar: ', err);
        this.showAlert('error', 'Error', 'No se pudo copiar el enlace.');
      });
    },
    showAlert(type, title, message) {
      this.alert = { show: true, type, title, message };
      setTimeout(() => {
        this.alert.show = false;
      }, 4000);
    },
    // ======= Landing Settings =======
    async fetchLandingSettings() {
      try {
        const res = await this.axios.get('distributor/landing/settings');
        if (res.data && res.data.data) {
          this.highlightedCourseIds = [...(res.data.data.highlighted_course_ids || [])];
          this.savedHighlightedIds = [...this.highlightedCourseIds];
          if (res.data.data.landing_url) {
            const parts = res.data.data.landing_url.split('/');
            this.username = parts[parts.length - 1] || this.username;
          }
        }
      } catch (err) {
        console.warn('Could not fetch landing settings:', err);
      }
    },
    isHighlighted(courseId) {
      return this.highlightedCourseIds.includes(courseId);
    },
    toggleHighlight(course) {
      const idx = this.highlightedCourseIds.indexOf(course.id);
      if (idx >= 0) {
        this.highlightedCourseIds.splice(idx, 1);
      } else {
        if (this.highlightedCourseIds.length >= 20) {
          this.showAlert('error', 'Límite alcanzado', 'Solo puedes destacar hasta 20 cursos.');
          return;
        }
        this.highlightedCourseIds.push(course.id);
      }
    },
    async saveLandingSettings() {
      try {
        this.savingSettings = true;
        await this.axios.post('distributor/landing/settings', {
          course_ids: this.highlightedCourseIds
        });
        this.savedHighlightedIds = [...this.highlightedCourseIds];
        this.showAlert('success', '¡Guardado!', 'Tus cursos destacados se actualizaron correctamente.');
      } catch (err) {
        console.error('Error saving landing settings:', err);
        this.showAlert('error', 'Error', 'No se pudieron guardar los cambios.');
      } finally {
        this.savingSettings = false;
      }
    },
    copyLandingLink() {
      navigator.clipboard.writeText(this.landingFullUrl).then(() => {
        this.linkCopied = true;
        this.showAlert('success', '¡Enlace Copiado!', 'Tu enlace de landing se copió al portapapeles.');
        setTimeout(() => { this.linkCopied = false; }, 3000);
      }).catch(() => {
        this.showAlert('error', 'Error', 'No se pudo copiar el enlace.');
      });
    }
  }
};
</script>

<style scoped>
/* Transiciones simples para alertas */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Custom Brand Green Styles */
.badge-price {
  background-color: var(--primary-color, #18d600);
  color: white;
  padding: 0.375rem 0.75rem;
  font-weight: bold;
  font-size: 0.875rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.badge-marketing {
  background-color: rgba(24, 214, 0, 0.15);
  color: #12a100;
  padding: 0.375rem 0.75rem;
  font-weight: 600;
  font-size: 0.75rem;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
}
.badge-marketing:hover {
  background-color: rgba(24, 214, 0, 0.25);
}

.btn-share {
  background-color: #111827; /* gray-900 */
  color: white;
  font-weight: 600;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  transition: all 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.dark .btn-share,
:global(.dark) .btn-share {
  background-color: #1e293b; /* slate-800 */
  border: 1px solid #334155; /* slate-700 */
  color: #f8fafc;
}
.btn-share:hover {
  background-color: var(--primary-color, #18d600) !important;
  border-color: transparent !important;
  color: white !important;
}
</style>
